import React, { useState, useEffect } from "react";
import { Button, Collapse, Empty, Pagination, Table, notification } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import StoreMenuForm from "./StoreMenuForm";
import {
  update_selected_menu,
  update_visibility,
} from "../slices/restaurantSlice";
import { _get_store_menus, _delete_menu_ } from "../common/axios_services";
import NumberFormat from "react-number-format";
import MenuDrawer from "./MenuDrawer";
import useCategories from "../hooks/useCategories";

const StoreMenuContent = ({
  page,
  per_page,
  handlePageChange,
  onShowSizeChange,
  updateCount,
  user,
  categories,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedMenu = useSelector((state) => state.restaurant.selectedMenu);
  const visible = useSelector((state) => state.restaurant.visible);
  const activeMenuTab = useSelector((state) => state.restaurant.activeMenuTab);
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updateCountLocal, setUpdateCountLocal] = useState(updateCount);

  const handleMenuClick = (menu) => {
    dispatch(update_selected_menu(menu));
    dispatch(update_visibility(true));
  };

  const drawerVisibility = () => {
    dispatch(update_visibility(!visible));
    if (selectedMenu) {
      dispatch(update_selected_menu(null));
    }
  };

  const handleDeleteMenu = async () => {
    if (selectedMenu) {
      try {
        let response;
        response = await _delete_menu_(selectedMenu.id);
        openNotificationWithIcon(
          "success",
          response?.data?.title || "Deleted successfully"
        );
        callback();
        drawerVisibility();
      } catch (err) {
        openNotificationWithIcon("error", "Failed to delete");
      }
    }
  };

  const openNotificationWithIcon = (type, title, message) => {
    notification[type]({
      message: title,
      description: message,
      placement: "bottom-right",
    });
  };
  const fetchStores = async () => {
    try {
      setLoading(true);
      const response = await _get_store_menus(user?.business?.id);
      setStores(response.data.data || []);
    } catch (err) {
      console.error("Failed to fetch stores:", err);
      openNotificationWithIcon("error", "Error", "Failed to fetch stores");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStores();
  }, []);

  const callback = () => {
    fetchStores();
  };

  const menuColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      ellipsis: true,
      render: (text) => <div className="line-clamp-1">{text}</div>,
    },
    {
      title: "Capacity",
      dataIndex: "capacity",
      key: "capacity",
    },
    {
      title: "Opening Stock",
      dataIndex: "openingStock",
      key: "openingStock",
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (text) => `NGN${parseFloat(text || 0).toFixed(2)}`,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Button type="link" onClick={() => handleMenuClick(record)}>
          Edit
        </Button>
      ),
    },
  ];

  return (
    <div className={"mt-10"}>
      {stores.length === 0 ? (
        <Empty description="No store items available. Create a new item.">
          <Button
            type="primary"
            onClick={drawerVisibility}
            className="add-menu-button mx-auto rounded-xl"
            icon={<PlusOutlined />}
          >
            Create Item
          </Button>
        </Empty>
      ) : (
        <>
          <div className="desktop show-all">
            <Table
              columns={menuColumns}
              dataSource={stores}
              pagination={false}
              rowKey="id"
              scroll={{ x: "max-content" }}
            />
            <Pagination
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              defaultCurrent={1}
              total={stores.length}
              current={page}
              pageSize={per_page}
              onChange={handlePageChange}
              className="mt-4"
            />
          </div>
          <div className="mobile topup-data">
            <Collapse defaultActiveKey={[0]}>
              {stores &&
                stores.length > 0 &&
                stores.map((item, index) => (
                  <Collapse.Panel
                    showArrow={false}
                    key={index}
                    header={
                      <p style={{ display: "inline" }}>
                        {item.name}&nbsp;-&nbsp;
                        <span className="small_currency">NGN</span>
                        <NumberFormat
                          thousandSeparator={true}
                          prefix={""}
                          className="numeric"
                          displayType={"text"}
                          value={parseFloat(item.price).toFixed(2)}
                        />
                      </p>
                    }
                  >
                    <div>
                      <ul className="mobile-list-flex">
                        <li className="flex gap-4">
                          <span>Name:</span>
                          <span className="text-right">{item.name}</span>
                        </li>
                        <li className="flex gap-4">
                          <span>Capacity:</span>
                          <span>{(() => {
                            if (!item.capacity) return "N/A";
                            const n = parseFloat(item.capacity);
                            const val = isNaN(n) ? item.capacity : (Number.isInteger(n) ? String(n) : String(parseFloat(n.toFixed(2))));
                            return `${val} ${item.unit || ''}`;
                          })()}</span>
                        </li>
                        <li className="flex gap-4">
                          <span>Opening Stock:</span>
                          <span>{item.openingStock}</span>
                        </li>
                        <li className="flex gap-4">
                          <span>Price:</span>
                          <span>
                            <span className="small_currency">NGN</span>
                            <NumberFormat
                              thousandSeparator={true}
                              prefix={""}
                              className="numeric"
                              displayType={"text"}
                              value={parseFloat(item.price).toFixed(2)}
                            />
                          </span>
                        </li>
                        <li className="flex gap-4">
                          <span>Action:</span>
                          <span>
                            <Button
                              type="link"
                              onClick={() => handleMenuClick(item)}
                            >
                              Edit
                            </Button>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </Collapse.Panel>
                ))}
            </Collapse>
            <div style={{ marginTop: "2%" }}></div>
            <Pagination
              showSizeChanger
              onShowSizeChange={onShowSizeChange}
              defaultCurrent={1}
              // total={menuTotal}
              current={page}
              pageSize={per_page}
              onChange={handlePageChange}
              className="mt-4"
            />
          </div>
        </>
      )}

      <MenuDrawer
        visible={activeMenuTab === "store" ? visible : false}
        title="Manage Retail Menu"
        selectedMenu={selectedMenu}
        drawerVisibility={drawerVisibility}
      >
        <StoreMenuForm
          selectedMenu={selectedMenu}
          categories={categories}
          drawerVisibility={drawerVisibility}
          updateCount={updateCountLocal}
          callback={callback}
          user={user}
          setUpdateCount={setUpdateCountLocal}
          navigate={navigate}
        />
        {selectedMenu && (
          <div className="mt-4">
            <button
              type="button"
              onClick={handleDeleteMenu}
              className="menu-update-btn bg-red-500 text-white hover:bg-red-600 border-none px-10 py-3 rounded-xl tracking-wider transition-colors"
            >
              Delete Menu
            </button>
          </div>
        )}
      </MenuDrawer>
    </div>
  );
};

export default StoreMenuContent;
